var faq_list = {
    _masonry: "",
    _interval: 0,
    init: function () {
        console.log("FAQ INIT");

        $(".faq-menu-container .faq-menu").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            faq_list.changeFAQ($(this).index());
        })
        faq_list._masonry = $('.faq-product--container .question-container').masonry({
            // options
            itemSelector: '.faq-container',
            gutter: 20,
            percentPosition: true,
            horizontalOrder: true,
            transitionDuration: 0
        });
        $('.faq__question').on('click', function (e) {
            // if (e.type == 'touchend') {
            //   $(this).off('click');
            // }
            clearInterval(faq_list._interval);
            var count = 0;
            faq_list._interval = setInterval(function () {
                count++;
                faq_list._masonry.masonry();
                if (count > 6) {
                    clearInterval(faq_list._interval);
                }
            }, 40);
        })
    },
    changeFAQ:function(pID){
        $(".faq-menu-container .faq-menu").each(function(){
            if($(this).index() == pID){
                $(this).addClass("selected");
            }else{
                $(this).removeClass("selected");
            }
        });
        $(".faq--container .question-container").each(function(){
            $(this).removeClass("prev selected next");

            if($(this).index() == pID){
                $(this).addClass("selected");
            }else if ($(this).index() < pID){
                $(this).addClass("prev");
            }else{
                $(this).addClass("next");
            }
        })
    }
}
$(window).on("load", function () {
    if ($(".faq-product--container").length) {
        faq_list.init();
    }
})
